import React, { Component } from "react"
import ReactDOM from 'react-dom';
import { AccountSearchFormSmall } from '../search/AccountSearchFormSmall.jsx';
import I18n from 'i18n-js';

export class PersonSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue || "",
      personOptions: this.props.personOptions,
      showSearch: false
    }
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleAddPerson = this.handleAddPerson.bind(this);
  }

  handleNameChange(e) {
    this.setState({ value: e.target.value });
    this.props.handleChange(e.target.value);
    if (e.target.value === "new") {
      this.setState({ showSearch: true })
    } else {
      this.setState({ showSearch: false })
    }
  }

  handleAddPerson(e, target) {
    this.setState({
      personOptions: this.state.personOptions.concat([e].map(this.personAsOption)),
      value: e.id,
      showSearch: false
    })
    this.props.handleChange(e.id);
  }

  personAsOption(x) {
    return <option key={x.id} value={x.id}>{x.name}</option>;
  };

  render() {
    return (
      <div>
        <div>
          <div className={"control-group select " + this.props.field + (this.props.required ? ' required' : ' optional')}>
            <label className={"select control-label " + (this.props.required ? 'required' : 'optional')}>
              {this.props.required ? <abbr title="required">* </abbr> : undefined}
              {this.props.label}
            </label>
            <div className="controls">
              <select required={this.props.required} value={this.state.value} id={this.props.person} onChange={this.handleNameChange}>
                <option key="new" value="new">{I18n.t("user.person_not_my_account")}</option>
                { <option key="0" value=""></option> }
                {this.state.personOptions}
              </select>
            </div>
          </div>
        </div>
        { this.state.showSearch ?
          <AccountSearchFormSmall
            target={this.state.showSearch}
            addPerson={this.handleAddPerson}
            company={this.props.company}
            />
          : undefined
        }
      </div>
    );
  }
}
